import { AioExternalSingle } from "../../additional/interface";
import { AitRowData } from "./AitRowData";
import { AitHeaderRowData } from "./interface";
import { replaceCellText } from "./replaceCellText";

/**
 * Apply a list of single-text external replacements to rows.
 *
 * For each `externalSingles` entry the function will replace occurrences of
 * `oldText` with `newText` in every cell of `newRows` using `replaceText`.
 *
 * @template T - Cell payload type
 * @template R - Row type (body or header)
 * @param externalSingles - External single replacement specifications
 * @param newRows - Rows to apply replacements to
 * @param replaceText - Replacement function for payload values
 * @returns The transformed rows array
 */
export function singleReplacements<T, R extends AitRowData<T> | AitHeaderRowData<T>>(
  externalSingles: AioExternalSingle<T>[] | undefined,
  newRows: R[],
  replaceText: (s: T, oldPhrase: string, newPhrase: T) => T,
): R[] {
  if (externalSingles !== undefined && externalSingles.length > 0) {
    externalSingles.forEach((e) => {
      /* istanbul ignore else */
      if (e.oldText !== "") {
        newRows = newRows.map((r) => {
          return {
            ...r,
            cells: r.cells.map((c) => replaceCellText(c, e.oldText, e.newText, replaceText)),
          };
        });
      }
    });
  }
  return newRows;
}
